import { render, staticRenderFns } from "./agent_index.vue?vue&type=template&id=10b6b0d3&"
import script from "./agent_index.vue?vue&type=script&lang=js&"
export * from "./agent_index.vue?vue&type=script&lang=js&"
import style0 from "./agent_index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports